import DatabaseModel from './DatabaseModel.js';

var Desempeno = Object.create(DatabaseModel);

Desempeno.model = 'dashboard';

// C5: ficha de desempeño del inspector (SOLO LECTURA; el backend guarda su foto en prod_desempeno).
// data = { codigoPersonal, anio, mes }
Desempeno.ficha = function(params) {
    var self = this;
    params = params || {};
    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/desempeno',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(request, false);
};

export default Desempeno;
